"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Environment = void 0;
const factory_1 = __importDefault(require("./factory"));
const enums_1 = require("./enums");
Object.defineProperty(exports, "Environment", { enumerable: true, get: function () { return enums_1.Environment; } });
exports.default = factory_1.default;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvc3BsaXQvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsd0RBQWlEO0FBRWpELG1DQUFzQztBQUk3Qiw0RkFKQSxtQkFBVyxPQUlBO0FBRnBCLGtCQUFlLGlCQUF3QixDQUFDIn0=


// WEBPACK FOOTER //
// ../../../src/split/index.ts